import { createSelector } from 'reselect';
import { appState } from './utils';
export const getDialogState = createSelector(appState, (state) => state.credentials.isDialogOpen);
export const getCredentials = createSelector(appState, (state) => {
    const credentials = {
        username: state.credentials.userName,
        password: state.credentials.password,
    };
    return credentials;
});
